export const MODULES = {
  dashboard: "dashboard",
  analytics: "analytics",
  inbox: "inbox",
  client: "client",
  account: "account",
  kyc: "kyc",
  wallet: "wallet",
  commission: "commission",
  ib_manager: "ib_manager",
  sales: "sales",
  report: "report",
  banner: "banner",
  subadmin: "subadmin",
  support: "support",
  tutorial: "tutorial",
  email_template: "email_template",
  email_marketing: "email_marketing",
  account_type: "account_type",
  setting: "setting",
  log: "log",
  cash_deposit: "cash_deposit",
  // Sub-modules
  withdraw: "withdraw",
  deposit: "deposit",
  credit: "credit",
  internal_transfer: "internal_transfer",
  comm_generate: "comm_generate",
  comm_withdraw: "comm_withdraw",
  comm_report: "comm_report",
  plan: "plan",
  leads: "leads",
  source: "source",
  volume_report: "volume_report",
  office_goals: "office_goals",
  team_goals: "team_goals",
  ftd_report: "ftd_report",
  ticket: "ticket",
  faq: "faq",
  notification: "notification",
  rule: "rule",
  tnc: "tnc",
  psp: "psp",
  threshold: "threshold",
  symbol: "symbol",
  bank_detail: "bank_detail",
  deposit_request: "deposit_request",
  usd_conversion: "usd_conversion",
  sales_office: "sales_office",
};

export const ACTIONS = {
  view: "view",
  create: "create",
  update: "update",
  delete: "delete",
  export: "export",
  import: "import",
  accept_reject: "accept_reject",
  login: "login",
  change_password: "change_password",
  update_permission: "update_permission",
  ticket_action: "ticket_action",
  ticket_assign: "ticket_assign",
  view_password: "view_password",
  send_ib_request: "send_ib_request",
  ib_details: "ib_details",
  parent_tree: "parent_tree",
  ib_tree: "ib_tree",
  change_mt5_password: "change_mt5_password",
  send_crm_credentials: "send_crm_credentials",
  send_notification: "send_notification",
  client_kyc: "client_kyc",
  client_accounts: "client_accounts",
  client_deposit: "client_deposit",
  client_withdraw: "client_withdraw",
  client_log: "client_log",
  view_transaction_charges: "view_transaction_charges",
  update_transaction_charges: "update_transaction_charges",
  sync: "sync",
};

export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;

export const getReferralRegistrationLink = (referralCode) =>
  referralCode ? `${CLIENT_URL}/?tab=register&ref=${referralCode}` : "";

export const ProofTypeOptions = [
  {
    value: 1,
    label: "Proof of Identity",
    subTypeOptions: [
      { value: 1, label: "International Passport" },
      { value: 2, label: "Driver License -- Front" },
      { value: 3, label: "Driver License -- Back" },
    ],
  },
  {
    value: 2,
    label: "Proof of Residence",
    subTypeOptions: [{ value: 4, label: "Credit Card Statement" }],
  },
  {
    value: 3,
    label: "Corporate Certificate",
    subTypeOptions: [{ value: 5, label: "Certificate Of Incorporation" }],
  },
  {
    value: 4,
    label: "Corporate",
    subTypeOptions: [
      { value: 6, label: "Company Extract" },
      { value: 7, label: "Memorandum" },
      { value: 8, label: "Articles Of Association," },
      { value: 9, label: "Certificate Of Incumbency" },
      { value: 10, label: "Other" },
    ],
  },
];

export const documentTypes = {
  1: "Proof of Identity",
  2: "Proof of Residence",
  3: "Corporate Certificate",
  4: "Corporate",
};

export const positionTypes = { 1: "Director", 2: "Shareholder" };

export const documentSubTypes = {
  1: "International Passport",
  2: "Driver License -- Front",
  3: "Driver License -- Back",
  4: "Credit Card Statement",
  5: "Certificate Of Incorporation",
  6: "Company Extract",
  7: "Memorandum",
  8: "Articles Of Association",
  9: "Certificate Of Incumbency",
  10: "Other",
};
